import { Box, DashboardModule, Text } from '@domain-group/suit-theme'

import PublicationEditionHeader from '@components/PublicationEditionHeader'

import usePublicationEdition from '@hooks/usePublicationEdition'

import AgencyGroup from './AgencyGroup'

interface PublicationEditionGroupProps {
  agencyGroups: object,
  orderCount: number,
  publicationEditionId: number,
}

const PublicationEditionGroup = (props: PublicationEditionGroupProps) => {
  const { agencyGroups, orderCount, publicationEditionId } = props

  const { publication, publicationEdition } = usePublicationEdition({ id: publicationEditionId })

  const secondaryText = orderCount === 1 ? '1 Item' : `${orderCount} Items`

  return (
    <DashboardModule
      customHeader={(
        <PublicationEditionHeader
          publicationEdition={publicationEdition}
          // @ts-expect-error TS2339
          publicationTitle={publication.title}
        >
          <Text color="faintGrey" fontSize="small">{secondaryText}</Text>
        </PublicationEditionHeader>
      )}
    >
      <Box flexDirection="column">
        {Object.values(agencyGroups).map((agencyGroup, i, arr) => (
          <AgencyGroup
            agencyGroup={agencyGroup}
            isLastGroup={arr.length - 1 === i}
            key={agencyGroup.id}
          />
        ))}
      </Box>
    </DashboardModule>
  )
}

export default PublicationEditionGroup
